import {Action, FlagProps} from 'platform/components';

import {VehiclePhotoResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export type VehicleWidgetData = {
  id: string;
  vin?: string | null;
  registrationPlate?: string | null;

  firstRegistration?: string | null;
  firstRegistrationOn?: string | null;

  make?: string | null;
  vehicleType?: string;
  type?: string;

  modelFamily?: string | null;
  trim?: string | null;
  variant?: string | null;
  mileage?: number | null;
  fuelType?: string | null;
  transmission?: string | null;
  bodyStyle?: string | null;

  driveType?: string | null;
  drive?: string | null;

  flags?: Pick<FlagProps, 'colorScheme' | 'label'>[];

  photos?: VehiclePhotoResponseBody[] | Nullish;
  actions?: Action[];
  firstParameter?: string | Nullish;
  secondParameter?: string | Nullish;
  manufacturedOn?: string | Nullish;
};
